import { Provider } from "react-redux";
import store from "./store";
import Routes from "routes";

import "./custom.scss";

export default function App() {
  return (
    <Provider store={store}>
      <Routes />
    </Provider>
  );
}
